/**
 * Start: Set webpack runtime variables
 */

// set the nonce for script and style tags loaded during runtime
__webpack_nonce__ = window.znRuntime?.cspStrictValue || '';

/**
 * End
 */

import createCache from '@emotion/cache';
import { createRoot } from 'react-dom/client';

import '@/Styles';
import '@/Utility/initApp';
import 'react-toastify/dist/ReactToastify.css';

import { CacheProvider as EmotionCacheProvider } from '@emotion/react';
import { CssBaseline } from '@mui/material';
import React from 'react';
import { RelayEnvironmentProvider } from 'react-relay';
import { ToastContainer } from 'react-toastify';
import ErrorBoundary from './Components/ErrorBoundary';
import { TsRouterProvider } from './RouterProvider';
import MuiThemeWrapper from './Utility/ThemeWrapper';
import { AuthProvider } from './Utility/auth/Auth';
import { isLocalhost } from './Utility/utils';
import { RelayEnvironment } from './graphql/relay-env';

// https://emotion.sh/docs/cache-provider
export const myCache = createCache({
  key: 'nonce',
  nonce: window.znRuntime?.cspStrictValue || '',
});

// titpwyl: This Is The Page Where You Landed;
const key = 'zn/titpwyl';
localStorage.setItem(key, window.location.pathname);

export const getPageWhereYouLanded = (): string | null => {
  return localStorage.getItem(key);
};

const App = () => {
  return (
    <React.StrictMode>
      <ErrorBoundary onError={{ ...(isLocalhost() ? {} : { reload: '/' }) }}>
        <EmotionCacheProvider value={myCache}>
          <RelayEnvironmentProvider environment={RelayEnvironment}>
            <CssBaseline>
              <MuiThemeWrapper>
                <AuthProvider>
                  <TsRouterProvider />
                  <ToastContainer position={'bottom-right'} draggable style={{ zIndex: 10000 }} stacked />
                </AuthProvider>
              </MuiThemeWrapper>
            </CssBaseline>
          </RelayEnvironmentProvider>
        </EmotionCacheProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
};

createRoot(document.getElementById('app')!).render(<App />);
